import { contentfulReqV2 } from './api/server';
import { contentful, ContentfulQueryKeys, LinkMap } from '@oresundsbron/api';
import { allLanguages } from './languages';
import { QueryClient } from '@tanstack/react-query';

let _cachedAllLinks: Record<string, LinkMap> | null = null;

const fetchAllLinks = async (
  preview: boolean = false
): Promise<Record<string, LinkMap>> => {
  if (!_cachedAllLinks) {
    const req = await contentfulReqV2();
    _cachedAllLinks = await contentful.Links.listV2(
      { preview, locales: allLanguages },
      req
    );
  }

  return _cachedAllLinks;
};

export const getAllLinksForAllLocales = async (
  preview: boolean = false
): Promise<Record<string, LinkMap>> => fetchAllLinks(preview);

export const getAllLinksForLocale = async (
  locale: string,
  preview: boolean = false,
  queryClient?: QueryClient
): Promise<LinkMap> => {
  const allLinks = await fetchAllLinks(preview);
  const localized = allLinks[locale];

  if (queryClient) {
    queryClient.setQueryData(
      ContentfulQueryKeys.LinksV2({ locales: [locale], preview }),
      localized
    );
  }

  return localized;
};
